export default __webpack_public_path__ + "img/c14ea173ea858e10977dce4f7c5b4d06.jpg";